import React from "react";
import PlaceProducts from "../components/UI/reusable-components/PlaceProducts/PlaceProducts";

export const PlaceProductPage = () => {
    return (
        <div>
            <PlaceProducts />
        </div>
    );
};